export default __webpack_public_path__ + "static/media/41-5-Monaco2018.ddd19b9b.jpg";